<!-- <mat-form-field class="example-full-width select-input">
    <input matInput [placeholder]="placeholder" (keydown)="onInputChange($event)" [(ngModel)]="itemValue" >
</mat-form-field> -->
<div class="answer-option">
    <input class="select-input" [attr.id]="indexValue+'_'+setsValue+'_'+type" [placeholder]="placeholder || ''"
        (keyup)="onInputChange($event)" (focus)="onInputFocus($event)" [(ngModel)]="itemValue"
        [disabled]="isDisabled" appPreventDrop />
</div>
